var _style, _defs, _path, _path2, _path3, _path4, _path5, _defs2, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChicken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 103 102",
    style: {
      enableBackground: "new 0 0 103 102"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;}\r\n\t.st2{clip-path:url(#SVGID_00000165917795192090877120000010865169631021542290_);}\r\n\t.st3{fill:#E86E7B;}\r\n\t.st4{clip-path:url(#SVGID_00000038414418660221095930000006813196652446320057_);}\r\n")), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 0.5,
    y: 0,
    width: 102,
    height: 102
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000121237949216154659710000006245476105760467901_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000121237949216154659710000006245476105760467901_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M98.2,93.5h-85c-1.1,0-2.2-0.4-3-1.2c-0.8-0.8-1.2-1.9-1.2-3v-85c0-1.1-0.4-2.2-1.2-3C7,0.4,5.9,0,4.8,0 s-2.2,0.4-3,1.2C0.9,2,0.5,3.1,0.5,4.2v85c0,3.4,1.3,6.6,3.7,9s5.6,3.7,9,3.7h85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3 s-0.4-2.2-1.2-3C100.5,93.9,99.4,93.5,98.2,93.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M64.3,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3V51c0-1.1-0.4-2.2-1.2-3c-0.8-0.8-1.9-1.2-3-1.2 s-2.2,0.4-3,1.2S60,49.9,60,51v29.8c0,1.1,0.4,2.2,1.2,3C62,84.6,63.1,85,64.3,85z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M30.2,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3V51c0-1.1-0.4-2.2-1.2-3s-1.9-1.2-3-1.2 s-2.2,0.4-3,1.2S26,49.9,26,51v29.8c0,1.1,0.4,2.2,1.2,3C28,84.6,29.1,85,30.2,85z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M81.2,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3v-51c0-1.1-0.4-2.2-1.2-3c-0.8-0.8-1.9-1.2-3-1.2 s-2.2,0.4-3,1.2c-0.8,0.8-1.2,1.9-1.2,3v51c0,1.1,0.4,2.2,1.2,3C79,84.6,80.1,85,81.2,85z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M47.2,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3v-51c0-1.1-0.4-2.2-1.2-3s-1.9-1.2-3-1.2 s-2.2,0.4-3,1.2c-0.8,0.8-1.2,1.9-1.2,3v51c0,1.1,0.4,2.2,1.2,3C45,84.6,46.1,85,47.2,85z"
  })))))))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000023253586262551584230000012917563129237692560_",
    x: 8.7,
    y: 8.1,
    width: 85.8,
    height: 85.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000132767448780461771710000009487365141949384118_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000023253586262551584230000012917563129237692560_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000132767448780461771710000009487365141949384118_)"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7,38.4c1.4,0,2.5-1.1,2.5-2.5c0-1.4-1.1-2.5-2.5-2.5c-1.4,0-2.5,1.1-2.5,2.5C59.2,37.3,60.3,38.4,61.7,38.4z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6,38.4c1.4,0,2.5-1.1,2.5-2.5c0-1.4-1.1-2.5-2.5-2.5c-1.4,0-2.5,1.1-2.5,2.5C39.1,37.3,40.2,38.4,41.6,38.4z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2,85.3v-9.2c0-0.5,0-0.3,0-0.5c6.8-7.2,10.1-17.3,10.1-27.2c0-18.3-11-33.6-25.1-35.2v-2.7c0-1.4-1.1-2.5-2.5-2.5 c-1.4,0-2.5,1.1-2.5,2.5v2.7C35,14.9,24,30.2,24,48.5c0,9.9,3.3,20,10.1,27.2v0.5v9.2l-4.3,4.3c-1,1-1,2.6,0,3.6c1,1,2.6,1,3.6,0 l3.3-3.3l3.3,3.3c1,1,2.6,1,3.6,0c1-1,1-2.6,0-3.6l-4.3-4.3v-5.4c3.8,2.5,8.1,3.8,12.6,3.8s8.7-1.3,12.6-3.8v5.4l-4.3,4.3 c-1,1-1,2.6,0,3.6c1,1,2.6,1,3.6,0l3.3-3.3l3.3,3.3c1,1,2.6,1,3.6,0c1-1,1-2.6,0-3.6L69.2,85.3z M36.9,71.4 c-4.7-5.4-7.7-13.2-7.9-22c5.9,2.1,10,7.8,10,14.2C39.1,66.4,38.3,69,36.9,71.4z M64.1,50.4c-3.2,3.7-4.9,8.3-4.9,13.2 c0,4,1.2,8,3.5,11.3c-3.3,2.4-7,3.8-11,3.8s-7.7-1.4-11-3.8c2.2-3.3,3.5-7.2,3.5-11.3c0-4.9-1.8-9.6-4.9-13.2 c-2.6-3-6.1-5.2-9.9-6.2c1.5-14.2,10.8-26,22.4-26c11.7,0,20.9,11.9,22.4,26C70.2,45.2,66.8,47.3,64.1,50.4z M66.4,71.4 c-1.4-2.3-2.2-5-2.2-7.8c0-6.4,4.2-12.1,10-14.2C74.1,58.1,71.1,66,66.4,71.4z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4,44.2l-5-5c-1-1-2.6-1-3.6,0l-5,5c-0.8,0.8-1,1.9-0.5,2.9l5,10.1c0.4,0.9,1.3,1.4,2.2,1.4c1,0,1.8-0.5,2.2-1.4 l5-10.1C59.4,46.1,59.2,45,58.4,44.2z M51.6,50.4l-2-3.9l2-2l2,2L51.6,50.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChicken);
export default __webpack_public_path__ + "static/media/Chicken.7ce6c9c86e78ce8456a984658b5b5548.svg";
export { ForwardRef as ReactComponent };